import { useContext, useEffect } from "react";
import clsx from "clsx";
import Markdown from "react-markdown";
import { usePage } from "@tree-company/tree-query";
import { usePageEffects } from "../hooks/use_page_effects";
import { LocaleContext } from "../app";
import { recommendationKeys } from "../survey";
import { BoostItem } from "./boost/boost_item";
import { StarSelectedIcon } from "./icons";
import { markCompleted } from "../completion";
import { Button } from "./button";

export function EndPage({ className, page, children, onPreviousPage }) {
  const { title, htmlAttributes, key } = usePage(page);
  const { translate } = useContext(LocaleContext);
  usePageEffects({ key });
  useEffect(markCompleted, []);

  return (
    <div className={clsx(className, "page", "page--end", htmlAttributes.class)}>
      <div className="page__main">
        {title && (
          <div className="page-intro">
            <h1 className="page__title">{title}</h1>
          </div>
        )}
        <div className="cards-wrapper">{children}</div>
      </div>
      <div className="page__actions">
        <Button
          variation="clear"
          className="page__action page__action--previous"
          onClick={onPreviousPage}
          iconPrev
          srText
        >
          {translate("navigation.previous")}
        </Button>
      </div>
    </div>
  );
}

export function EndContent({ content, className }) {
  const { translate } = useContext(LocaleContext);
  const selected = content.treesponse.getAnswer("boost-priorities") ?? [];
  const selectedRecs = recommendationKeys.filter((key) =>
    selected.includes(key),
  );

  return (
    <>
      <div className={clsx("card", "end-content", className)}>
        <div className="end-content__body">
          <p className="end-content__subtitle card-title">
            {translate("end.subtitle")}
          </p>
          <Markdown>{translate("end.body")}</Markdown>
        </div>
      </div>
      <div className={clsx("card", "end-favorites")}>
        <h2 className="end-favorites__title card-title">
          <StarSelectedIcon />
          {translate("end.favorites_title")}
        </h2>
        {selectedRecs.length === 0 ? (
          <p className="boost-empty">{translate("end.empty")}</p>
        ) : (
          <div className="boost-list">
            {selectedRecs.map((key) => (
              <BoostItem
                key={key}
                option={{
                  value: key,
                  label: translate(`recommendations.${key}.short_title`),
                }}
                isSelected
              />
            ))}
          </div>
        )}
      </div>
    </>
  );
}
